<h2 mat-dialog-title>Modifier le nom de la session</h2>

<mat-dialog-content>
    <mat-form-field class="w-full">
        <mat-label>Nom de la session</mat-label>
        <input matInput type="text" [(ngModel)]="session.name" placeholder="BODEMER - AO 2025/637289">
    </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button matButton [mat-dialog-close]="false">Annuler</button>
    <button matButton (click)="updateSession()">Modifier</button>
</mat-dialog-actions>